import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import { round6 } from 'utilities/math';

import { ITALIC_P } from 'scenes/InferentialStatistics/Constants';

import {
  getTableData,
  getConfidenceInterval,
  getLimits,
  getStandardError,
  getIsGroupChosen,
  getDfValue
} from 'store/scenes/inferentialStatistics/selectors';

import { tableHeadersTwoSampleProportion } from '../shared';

const TwoProportionConfidenceInterval = () => {
  const tableData = useSelector(state => getTableData(state));
  const confidenceInterval = useSelector(state => getConfidenceInterval(state));
  const standardError = useSelector(state => getStandardError(state));
  const { lowerLimit, upperLimit } = useSelector(state => getLimits(state));
  const dfValue = useSelector(state => getDfValue(state));
  const isGroupChosen = useSelector(state => getIsGroupChosen(state));

  const tableHeaders = tableHeadersTwoSampleProportion(isGroupChosen);

  return (
    <div className="content-item">
      <h3 className="mb-20">Two Sample Proportion Confidence Interval Summary</h3>
      <div className="mb-5 pl-5">
        <p className="font-900 font-16 mb-5">{ITALIC_P}<sub>1</sub>: proportion of successes in population 1</p>
        <p className="font-900 font-16 ">{ITALIC_P}<sub>2</sub>: proportion of successes in population 2</p>
      </div>
      <span className="mr-5 mb-20 ml-5">
        {confidenceInterval}% Confidence Interval for {`${ITALIC_P}`}<sub>1</sub> - {`${ITALIC_P}`}<sub>2</sub>
      </span>

      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>Difference of Proportions</td>
            <td>
              <span>{round6(dfValue)}</span>
            </td>
          </tr>
          <tr>
            <td>Standard Error</td>
            <td>
              <span>{round6(standardError)}</span>
            </td>
          </tr>
          <tr>
            <td>Lower Limit </td>
            <td>
              <span>{round6(lowerLimit)}</span>
            </td>
          </tr>
          <tr>
            <td>Upper Limit </td>
            <td>
              <span>{round6(upperLimit)}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeaders} tableData={tableData} />
    </div>
  );
};

export default TwoProportionConfidenceInterval;

